export default __webpack_public_path__ + "static/dubizzle-group-white-1c171d16fb4dc5743fa8f4c6d9810353.png";